/**
 * Perfil da Linha de Cuidado no front (GMUD-2026-0029, item 15).
 *
 * Espelha a matriz do backend para decidir o que aparece na tela. A regra
 * efetiva continua sendo a do backend: aqui é só UX — esconder o que o
 * usuário não pode usar, para ele não esbarrar em 403.
 */

/** Estrutura vazia usada enquanto o perfil não carregou. */
export const PERFIL_VAZIO = {
    perfil: null,
    perfil_display: null,
    modulos_visiveis: [],
    permissoes: {},
    carregando: true,
};

/** O usuário enxerga o módulo? */
export const podeVer = (perfilLC, modulo) => {
    if (!perfilLC || perfilLC.carregando) return false;

    return (perfilLC.modulos_visiveis || []).includes(modulo);
};

const permissao = (perfilLC, modulo) => (perfilLC?.permissoes || {})[modulo] || {};

/** O usuário edita o módulo? */
export const podeEditar = (perfilLC, modulo) => Boolean(permissao(perfilLC, modulo).pode_editar);

/** O usuário inclui registros no módulo? */
export const podeIncluir = (perfilLC, modulo) => Boolean(permissao(perfilLC, modulo).pode_incluir);

/** O usuário exclui registros do módulo? */
export const podeExcluir = (perfilLC, modulo) => Boolean(permissao(perfilLC, modulo).pode_excluir);

/** Capacidade pontual concedida ao perfil (upload, incluir, reportar). */
export const permite = (perfilLC, modulo, acao) =>
    (permissao(perfilLC, modulo).permite || []).includes(acao);

/** Campos que o perfil enxerga no módulo (vazio = todos). */
export const camposVisiveis = (perfilLC, modulo) => permissao(perfilLC, modulo).campos || [];

/** Campos ocultados para o perfil no módulo. */
export const camposOcultos = (perfilLC, modulo) => permissao(perfilLC, modulo).ocultar || [];

/**
 * O campo aparece para o perfil?
 * Respeita tanto a lista de campos liberados quanto a de ocultos.
 */
export const campoVisivel = (perfilLC, modulo, campo) => {
    const campos = camposVisiveis(perfilLC, modulo);
    if (campos.length > 0) {
        return campos.includes(campo);
    }

    return !camposOcultos(perfilLC, modulo).includes(campo);
};

/** Perfil sem nenhum acesso à Linha de Cuidado. */
export const semAcessoLinhaCuidado = (perfilLC) =>
    Boolean(perfilLC) && !perfilLC.carregando && !perfilLC.perfil;
